import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const MachineAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/machines",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  categories: async function (cancel = false) {
    const response = await api.request({
      url: "/machines/categories",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  store: async function (data, cancel = false) {
    const response = await api.request({
      url: "/machines",
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  show: async function (machine, cancel = false) {
    const response = await api.request({
      url: "/machines/" + machine,
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  update: async function (machine, data, cancel = false) {
    const response = await api.request({
      url: "/machines/" + machine,
      method: "PUT",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  delete: async function (machine, cancel = false) {
    const response = await api.request({
      url: "/machines/" + machine,
      method: "DELETE",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(MachineAPI)